__turbopack_context__.v({
  "DialogContent": "styles-module__kVHBgG__DialogContent",
  "DialogDescription": "styles-module__kVHBgG__DialogDescription",
  "DialogOverlay": "styles-module__kVHBgG__DialogOverlay",
  "DialogTitle": "styles-module__kVHBgG__DialogTitle",
  "contentShow": "styles-module__kVHBgG__contentShow",
  "overlayShow": "styles-module__kVHBgG__overlayShow",
});
